import React from 'react';
import { SettingsLayout } from '../../../../design-system/components/layouts';
import { PageHeader } from '../../../../design-system/components';
import { admin_settings_webhooks_path } from '../../../../lib/routes';
import WebhookForm from './Form';
export default function New({ webhook, supported_events }) {
  return (
    <SettingsLayout>
      <PageHeader
        title="New Webhook Endpoint"
        description="Create a new outbound webhook endpoint"
      />

      <div className="mt-6">
        <WebhookForm
          webhook={webhook}
          action={admin_settings_webhooks_path()}
          method="post"
          supported_events={supported_events}
        />
      </div>
    </SettingsLayout>
  );
}
